import React from "react";
import { ArrayFieldTemplateItemType } from "@rjsf/utils";
import { Templates } from "@rjsf/antd";
import styles from "../../pages/tenants/tenants.module.css";

const { ArrayFieldItemTemplate } = Templates;

export const ConfirmingArrayFieldItemTemplate = (props: ArrayFieldTemplateItemType) => (
  // @ts-ignore
  <ArrayFieldItemTemplate
    {...props}
    onDropIndexClick={(index: number) => () => {
      if (window.confirm("Are you sure you want to delete it?")) {
        props.onDropIndexClick(index)();
      }
    }}
  />
);
